import { render, staticRenderFns } from "./LimpiezaAgenda.vue?vue&type=template&id=4d48aa70"
import script from "./LimpiezaAgenda.vue?vue&type=script&lang=js"
export * from "./LimpiezaAgenda.vue?vue&type=script&lang=js"
import style0 from "./LimpiezaAgenda.vue?vue&type=style&index=0&id=4d48aa70&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports